t = require('app/scripts/views/internal/teacup-with-helpers')('organization_search_list_item')

module.exports = ->
  t.li ->
    t.a '.link-item', { href: '/' + t.mustacheVar('name') }, ->
      t.span '.item-name', ->
        t.text t.mustacheVar('displayName')
